import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import styled, {css, ThemeProvider} from 'styled-components';

import {getVideoFront} from '~/src/utilities/helpers/video';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {getThemes} from '~/src/utilities/helpers/brand';
import variables from '~/src/css/global.module.scss';
import {SiteArea} from '~/src/utilities/constants/navigation';

import {Breadcrumb as BreadcrumbMigrated} from '@components/molecules/breadcrumb';

const sassVariableHelper = (variable) => variables[variable];

const Migrated = styled(({migration, ...props}) => {
    const crumbs = props.crumbs.map((crumb) => {
        if (crumb.href) {
            crumb.href = crumb?.href.startsWith('/') ? crumb.href : '/' + crumb.href;
            if (crumb.href === '/lifestyle') {
                crumb.href = '/lifestyle/front';
            }
        }
        return crumb;
    });
    const properties = props;
    properties.crumbs = crumbs;

    return <BreadcrumbMigrated {...properties} />;
})`
    ${({migration}) => {
        if (migration.isLifestyle) {
            return css`
                color: ${sassVariableHelper('mainBackgroundColor')};
                margin: 0 10px 10px;
            `;
        }

        return css`
            margin: 0 10px 10px;
        `;
    }}
`;

const getCrumbs = (mainCategoryId, sitemap) => {
    let crumbs = [];
    let category = sitemap.getCategoryBy({categoryId: mainCategoryId});

    while (category) {
        crumbs.unshift({
            href: category.fullUrlPath === 'video' ? getVideoFront(sitemap.all).fullUrlPath : category.fullUrlPath,
            name: category.name
        });
        category = sitemap.getCategoryBy({categoryId: category.parent});
    }

    return crumbs.filter((crumb) => crumb);
};

const Themes = getThemes();
const PassThrough = (theme) => theme;

const Breadcrumb = ({mainCategoryId, title}) => {
    const sitemap = useContext(SitemapContext);
    const {siteArea} = useContext(SettingsContext);

    const crumbs = getCrumbs(mainCategoryId, sitemap);

    if (!crumbs.length) {
        return null;
    }

    if (!crumbs.some((crumb) => crumb.name === 'Front')) {
        crumbs.unshift({href: '/', name: 'Front'});
    }

    if (title) {
        crumbs.push({name: title});
    }

    const isLifestyle = siteArea === SiteArea.LIFESTYLE;
    const isVideoPage = siteArea === SiteArea.VIDEO;

    return (
        <ThemeProvider theme={isLifestyle ? Themes.LifestyleAlternative : isVideoPage ? Themes.Video : PassThrough}>
            <Migrated crumbs={crumbs} migration={{isLifestyle}} />
        </ThemeProvider>
    );
};

if (process.env.NODE_ENV === 'development') {
    Breadcrumb.propTypes = {
        mainCategoryId: PropTypes.number
    };
}

export default Breadcrumb;
